import React from 'react'
import FeedItem from './FeedItem'
import { Link } from 'react-router-dom'
/* REDUX */
import { formatHeading } from '../../utility/Formatter'

class Feed extends React.Component {
	
	constructor(props) {
		super(props)
	}
	
	render() {
		
		const { feed, reports, onLoadMoreClick, endOfDoc } = this.props
		
		const reportsList = reports.map(report => {
			return <FeedItem key={ report._id } {...report} onLogin={ this.props.onLogin } />
		})
		
		let formattedHeading = formatHeading(feed)

		return (
			<div className="feed">
				<ul>
					<li>
						<div className="stack">
							<h2 className="heading">{ formattedHeading }</h2>
						</div>
					</li>
					{ reportsList }
					<li>
						{!endOfDoc ? (
						<a onClick={ onLoadMoreClick } >
							<div className="stack fin">
								<span className="text">View More</span>
							</div>
						</a>
						):(
						<span>
							<div className="stack fin">
								<span className="text">End of Results</span>
							</div>
						</span>
						)}
					</li>
				</ul>
			</div>
		)
	}
}

export default Feed


// WEBPACK FOOTER //
// ./src/components/Global/Feed.js